import { render } from "./FollowupCashPayments.vue?vue&type=template&id=76b62cd7&scoped=true"
import script from "./FollowupCashPayments.vue?vue&type=script&lang=js"
export * from "./FollowupCashPayments.vue?vue&type=script&lang=js"

import "./FollowupCashPayments.vue?vue&type=style&index=0&id=76b62cd7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b62cd7"]])

export default __exports__